var map = {
	"./00-links/01.pug": 315,
	"./01-bio/01.pug": 316,
	"./01-bio/02.pug": 317,
	"./02-overview/01.pug": 318,
	"./02-overview/02.pug": 319,
	"./02-overview/03.pug": 320,
	"./03-variables/01.pug": 321,
	"./04-syntax/00.pug": 322,
	"./04-syntax/01.pug": 323,
	"./04-syntax/02.pug": 324,
	"./04-syntax/03.pug": 325,
	"./04-syntax/04.pug": 326,
	"./04-syntax/05.pug": 327,
	"./04-syntax/06.pug": 328,
	"./05-nulls-casts/01.pug": 329,
	"./05-nulls-casts/02.pug": 330,
	"./06-moar/01.pug": 331,
	"./06-moar/02.pug": 332,
	"./06-moar/03.pug": 333,
	"./06-moar/04.pug": 334,
	"./06-moar/05.pug": 335,
	"./06-moar/06.pug": 336,
	"./06-moar/07.pug": 337,
	"./07-javascript/01.pug": 338,
	"./08-live-code/01.pug": 339,
	"./08-live-code/02.pug": 340
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 381;


//////////////////
// WEBPACK FOOTER
// ./src/slides \.md|markdown|pug$
// module id = 381
// module chunks = 1